import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import '../../content/css/DangerButton.css';

export default class DangerButton extends Component {
    constructor(props, context) {
        super(props, context);

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleConfirm = this.handleConfirm.bind(this);

        this.state = {
            show: false
        };
    }

    handleConfirm() {
        this.setState({ show: false });
        this.props.onClick();
    }

    handleClose() {
        this.setState({ show: false });
    }

    handleShow() {
        this.setState({ show: true });
    }

    render() {
        return (
            <React.Fragment>
                <Button className="danger-btn" bsStyle="danger" onClick={this.handleShow}>{this.props.children}</Button>
                <Modal show={this.state.show} onHide={this.handleClose}>
                    <Modal.Body>
                        <h4>{this.props.warningText}</h4>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.handleConfirm}>Yes</Button>
                        <Button onClick={this.handleClose}>No</Button>
                    </Modal.Footer>
                </Modal>
            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Misc/DangerButton.js